import Add from './add.vue'

export default [{
    path: '/:type',
    name:'lyEmpAdd',
    component:Add,
}]